// superAdminServices.ts
import apiService from './apiService';

export const getShiftLog = async (page = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      page: String(page),
    });

    // ✅ correct query format: filter[search]
    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/shift-logs?${params.toString()}`);

    return response.data;
  } catch (error) {
    console.error('Error fetching shift logs:', error);
    throw error;
  }
};

export const deleteShiftLog = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/shift-logs/${id}`);
    return response.data; // return full API response
  } catch (error) {
    console.error('Error fetching shift logs:', error);
    throw error;
  }
};

export const getUsers = async (page = 1) => {
  try {
    const response = await apiService.get(`/users?page=${page}`);
    return response.data; // return full API response
  } catch (error) {
    console.error('Error fetching shift logs:', error);
    throw error;
  }
};

export const postShiftEvents = async (payload: { shift_log_id: number; event_time: string; description: string }) => {
  try {
    const response = await apiService.post(`shift-logs/${payload.shift_log_id}/shift-events`, payload);
    return response.data;
  } catch (error) {
    console.error('Error posting shift event:', error);
    throw error;
  }
};

export const getShiftLogDetails = async (id = 1) => {
  try {
    const response = await apiService.get(`/shift-logs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift logs:', error);
    throw error;
  }
};

export const postShiftSignedOff = async ({ shift_log_id, handover_remarks }: { shift_log_id: number; handover_remarks: string }) => {
  try {
    const response = await apiService.post(`shift-logs/${shift_log_id}/sign-off`, {
      shift_log_id,
      handover_remarks,
    });

    return response.data;
  } catch (error) {
    console.error('Error signing off shift:', error);
    throw error;
  }
};

// <-- Add this new function here:
export const postNotifyUpdate = async ({ shift_log_id }: { shift_log_id: number }) => {
  try {
    // Replace the endpoint with your real notify update API URL
    const response = await apiService.post(`shift-logs/${shift_log_id}/notify-update`, {
      shift_log_id,
    });
    return response.data;
  } catch (error) {
    console.error('Error posting notify update:', error);
    throw error;
  }
};

export const getSites = async () => {
  try {
    const response = await apiService.get(`/sites`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sites:', error);
    throw error;
  }
};

export const getShiftEventsByID = async (id = 1) => {
  try {
    const response = await apiService.get(`/shift-logs/${id}/shift-events`);
    return response.data;
  } catch (error) {
    console.error('Error fetching shift events by ID:', error);
    throw error;
  }
};

export const downloadShiftReport = async (id: number | string) => {
  try {
    const response = await apiService.get(`/shift-logs/${id}/download`, {
      responseType: 'blob', // Important for PDF
    });

    return response.data;
  } catch (error) {
    console.error('Error downloading shift report:', error);
    throw error;
  }
};
export const updateShiftEvent = async (shiftLogId: number, eventId: number, payload: any) => {
  try {
    const response = await apiService.put(`/shift-logs/${shiftLogId}/shift-events/${eventId}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating shift event:', error);
    throw error;
  }
};
